import { gql } from '@apollo/client'

export const Query = gql`
  query EditClientType($companyId: ID!, $filters: ClientTypeFilters) {
    clientTypes(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        color
      }
    }
  }
`
